import { Button, InputAdornment, OutlinedInput } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useContext } from "react";
import Context from "../../Context";
import Transfer from "./Transfer";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import consts from "../../constant";
import usercalls from "../../Axios";
import { toast } from "react-hot-toast";
import { useUserData } from "../../Contexts/UserContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  "@media (max-width: 767.98px)": {
    width: "90%",
  },
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: "20px 0",
};

const AssetView = () => {
  const { id } = useParams();
  const { balance } = useContext(Context);
  const { userData } = useUserData();
  const token = window.localStorage.getItem("Rikosta");
  const path = usercalls();
  const navigate = useNavigate();
  const loaction = useLocation();
  const placeRoute = loaction.pathname?.split("/")[1];

  //selet

  const [age, setAge] = useState(10);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const [selcData, setSelcData] = useState({});

  //model

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setAssetAmt("");
  };

  const [searchParams] = useSearchParams();

  const type = searchParams.get("type");

  var [secondBalance, setSecondBalance] = useState(0);
  var [firstBalance, setFirstBalance] = useState(0);

  var [secondEscrowBalance, setSecondEscrowBalance] = useState(0);
  var [firstEscrowBalance, setFirstEscrowBalance] = useState(0);

  const [browTab, setBrowTab] = useState("Borrow");
  const [browInnerTab, setBrowInnerTab] = useState("Cross");

  const [assetAmt, setAssetAmt] = useState(0);
  const [walletData, setWalletData] = useState([]);

  const handleWalletData = async () => {
    try {
      const url = `${consts.BackendUrl}/wallet/OwnWalletGet?page=1&limit=100`;
      const response = await path.postCall({
        url,
        payload: {
          search: "",
          hideZero: false,
          changeType: "margin",
          depositStatus: "true",
        },
      });
      const result = await response.json();
      // console.log("🚀 ~ handleWalletData ~ result:", result);

      if (result.success) {
        setWalletData(result.result.docs);
        if (result?.result?.docs?.length > 0) {
          setAge(result?.result?.docs[0]?.symbol);
          setSelcData(result?.result?.docs[0]);
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleBorrow = () => {
    if (userData?.kyc_verify == "true") {
      handleWalletData();
      handleOpen();
    } else {
      navigate("/kycverify");
      toast.error("Verify KYC to Borrow or Repay");
    }
  };

  const calculateAmount = async (per, type) => {
    try {
      if (type == "borrow") {
        if (per && selcData?.margin_amount) {
          const amount = (selcData?.margin_amount * per) / 100;
          setAssetAmt(amount);
        }
      } else if (type == "repay") {
        if (per && selcData?.margin_debt_amount) {
          const amount = (selcData?.margin_debt_amount * per) / 100;
          setAssetAmt(amount);
        }
      }
    } catch (error) {
      console.log("🚀 ~ calculateAmount ~ error:", error);
    }
  };

  const borrowAndRepay = async (type) => {
    try {
      const url = `${consts.BackendUrl}/ownTrade/manualBorrowOrRepay`;
      const response = await path.postCall({
        url,
        payload: {
          Type: type,
          Margin_Type: "cross",
          Amount: assetAmt,
          symbol: selcData?.symbol,
        },
      });
      const result = await response.json();
      // console.log("��� ~ borrowAndRepay ~ result:", result);

      if (result.success) {
        handleClose();
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("🚀 ~ borrowAndRepay ~ error:", error);
    }
  };

  useEffect(() => {
    if (placeRoute == "future") {
      setFirstBalance(
        balance?.first ? Number(balance?.first?.future_balance)?.toFixed(8) : 0
      );
      setSecondBalance(
        balance?.second
          ? Number(balance?.second?.future_balance)?.toFixed(8)
          : 0
      );

      setSecondEscrowBalance(
        balance?.second != null
          ? Number(balance?.second?.escrow_future_balance)?.toFixed(8)
          : 0
      );
      setFirstEscrowBalance(
        balance?.first != null
          ? Number(balance?.first?.escrow_future_balance)?.toFixed(8)
          : 0
      );
    } else {
      if (type == "spot") {
        setFirstBalance(
          balance?.first ? Number(balance?.first?.spot_balance)?.toFixed(8) : 0
        );
        setSecondBalance(
          balance?.second
            ? Number(balance?.second?.spot_balance)?.toFixed(8)
            : 0
        );

        setSecondEscrowBalance(
          balance?.second != null
            ? Number(balance?.second?.funding_balance)?.toFixed(8)
            : 0
        );
        setFirstEscrowBalance(
          balance?.first != null
            ? Number(balance?.first?.funding_balance)?.toFixed(8)
            : 0
        );
      } else if (type == "cross") {
        setFirstBalance(
          balance?.first
            ? Number(balance?.first?.margin_balance)?.toFixed(8)
            : 0
        );
        setSecondBalance(
          balance?.second
            ? Number(balance?.second?.margin_balance)?.toFixed(8)
            : 0
        );

        setSecondEscrowBalance(
          balance?.second != null
            ? Number(balance?.second?.escrow_margin_balance)?.toFixed(8)
            : 0
        );
        setFirstEscrowBalance(
          balance?.first != null
            ? Number(balance?.first?.escrow_margin_balance)?.toFixed(8)
            : 0
        );
      }
    }
  }, [balance, placeRoute, type]);

  return (
    <div>
      <div className="assets-overview">
        {/* <h4>Assets Overview</h4> */}
        <div className="display-2 ">
          <div className="aval">Trading Account</div>
          {/* <div className="display-1 usd">
                    <div className="">0 USDT</div>
                  </div> */}
        </div>
        <div className="display-2 ">
          <div className="aval">{id?.split("_")[1]}</div>
          <div className="display-1 usd">
            <div className="">
              {secondBalance} {id?.split("_")[1]}
            </div>
          </div>
        </div>
        <div className="display-2 ">
          <div className="aval">{id?.split("_")[0]}</div>
          <div className="display-1 usd">
            <div className="">
              {firstBalance} {id?.split("_")[0]}
            </div>
          </div>
        </div>
        <div className="display-2 ">
          <div className="aval">Funding Account</div>
          {/* <div className="display-1 usd">
                    <div className="">0 USDT</div>
                  </div> */}
        </div>
        <div className="display-2 ">
          <div className="aval">{id?.split("_")[1]}</div>
          <div className="display-1 usd">
            <div className="">
              {" "}
              {secondEscrowBalance} {id?.split("_")[1]}
            </div>
          </div>
        </div>
        <div className="display-2 ">
          <div className="aval">{id?.split("_")[0]}</div>
          <div className="display-1 usd">
            <div className="">
              {firstEscrowBalance} {id?.split("_")[0]}
            </div>
          </div>
        </div>
        {token ? (
          <div>
            <div className="display-2 mt-20">
              <div className="common-btn asset-btn">
                <Button
                  variant="contained"
                  onClick={() => {
                    navigate("/deposit");
                  }}
                >
                  Deposit{" "}
                </Button>
              </div>
              <div className="common-btn asset-btn crpto-btn">
                {/* <Button variant="contained">Transfer </Button> */}
                <Transfer />
              </div>
            </div>
            {placeRoute == "future" ? null : (
              <div className="display-2 mt-20">
                <div className="common-btn asset-btn">
                  <Button variant="contained" onClick={handleBorrow}>
                    Borrow/Repay
                  </Button>
                </div>
              </div>
            )}
          </div>
        ) : (
          //  : token && userData?.kyc_verify == "false" ? (
          //   <div className="display-3 mt-20">
          //     <div className="login-deposit-btn">
          //       <Button variant="contained" onClick={() => navigate("/kycverify")}>
          //         {" "}
          //         Verify KYC
          //       </Button>
          //     </div>
          //   </div>
          // )
          <div className="display-3 mt-20">
            <div className="login-deposit-btn">
              <Button variant="contained" onClick={() => navigate("/login")}>
                {" "}
                Login / Sign Up
              </Button>
            </div>
          </div>
        )}
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 br-shade p-20">
            <div className="display-1 gap-25">
              <div
                className={
                  browTab === "Borrow" ? "brow-btn active" : "brow-btn"
                }
                onClick={() => {
                  setBrowTab("Borrow");
                  setAssetAmt("");
                }}
              >
                Borrow
              </div>
              <div
                className={browTab === "Repay" ? "brow-btn active" : "brow-btn"}
                onClick={() => {
                  setBrowTab("Repay");
                  setAssetAmt("");
                }}
              >
                Repay
              </div>
            </div>
            <HighlightOffIcon
              sx={{ fontSize: "30px !important", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          {browTab === "Borrow" ? (
            <div className="p-20">
              <div className="display-2 brow-inner">
                <div
                  className={
                    browInnerTab === "Cross"
                      ? "brow-inner-btn active"
                      : "brow-inner-btn"
                  }
                  onClick={() => setBrowInnerTab("Cross")}
                >
                  Cross Margin
                </div>
                {/* <div
                  className={
                    browInnerTab === "Isolated"
                      ? "brow-inner-btn active"
                      : "brow-inner-btn dis"
                  }
                // onClick={() => setBrowInnerTab("Isolated")}
                >
                  Isolated Margin
                </div> */}
              </div>

              <Box
                sx={{ minWidth: 120, mt: 3, mb: 3 }}
                className="asset-select"
              >
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    onChange={handleChange}
                  >
                    {walletData?.map((item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item?.symbol}
                          onClick={() => {
                            setSelcData(item);
                            setAssetAmt("");
                          }}
                        >
                          <div className="display-1">
                            <img
                              width="25"
                              height="25"
                              src={item?.image}
                              alt="tether--v2"
                            />
                            {item?.symbol}
                          </div>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
              {/* <div className="display-2 brow-condt">
                <div>Reference Day Rate</div>
                <div>
                  {selcData?.loan_percentage ? selcData?.loan_percentage : 0}%
                </div>
              </div> */}
              <div className="display-2 brow-condt">
                <div>Liabilities</div>
                <div>{selcData?.margin_debt_amount}</div>
              </div>
              <div className="display-2 brow-condt">
                <div>Available</div>
                <div>{selcData?.margin_balance}</div>
              </div>
              <div className="display-2 brow-condt">
                <div>You can borrow</div>
                <div>{selcData?.margin_amount}</div>
              </div>
              <FormControl
                sx={{ mt: 3, mb: 3, width: "100%" }}
                variant="outlined"
                className="asset-input"
              >
                <OutlinedInput
                  id="outlined-adornment-weight"
                  type="number"
                  endAdornment={
                    <InputAdornment position="end">{age}</InputAdornment>
                  }
                  value={assetAmt}
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{
                    "aria-label": "weight",
                  }}
                  onChange={(e) => setAssetAmt(e.target.value)}
                />
              </FormControl>
              <div className="display-2 ">
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(25, "borrow")}
                >
                  25%
                </div>
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(50, "borrow")}
                >
                  50%
                </div>
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(75, "borrow")}
                >
                  75%
                </div>
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(100, "borrow")}
                >
                  100%
                </div>
              </div>
            </div>
          ) : (
            <div className="p-20">
              <div className="display-2 brow-inner">
                <div
                  className={
                    browInnerTab === "Cross"
                      ? "brow-inner-btn active"
                      : "brow-inner-btn"
                  }
                  onClick={() => setBrowInnerTab("Cross")}
                >
                  Cross Margin
                </div>
                {/* <div
                  className={
                    browInnerTab === "Isolated"
                      ? "brow-inner-btn active"
                      : "brow-inner-btn dis"
                  }
                  onClick={() => setBrowInnerTab("Isolated")}
                >
                  Isolated Margin
                </div> */}
              </div>

              <Box
                sx={{ minWidth: 120, mt: 3, mb: 3 }}
                className="asset-select"
              >
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    onChange={handleChange}
                  >
                    {walletData?.map((item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item?.symbol}
                          onClick={() => {
                            setSelcData(item);
                            setAssetAmt("");
                          }}
                        >
                          <div className="display-1">
                            <img
                              width="25"
                              height="25"
                              src={item?.image}
                              alt="tether--v2"
                            />
                            {item?.symbol}
                          </div>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>

              <div className="display-2 brow-condt">
                <div>Liabilities</div>
                <div>{selcData?.margin_debt_amount}</div>
              </div>
              <div className="display-2 brow-condt">
                <div>Available</div>
                <div>{selcData?.margin_balance}</div>
              </div>

              <FormControl
                sx={{ mt: 3, mb: 3, width: "100%" }}
                variant="outlined"
                className="asset-input"
              >
                <OutlinedInput
                  id="outlined-adornment-weight"
                  type="number"
                  endAdornment={
                    <InputAdornment position="end">USDT</InputAdornment>
                  }
                  value={assetAmt}
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{
                    "aria-label": "weight",
                  }}
                  onChange={(e) => setAssetAmt(e.target.value)}
                />
              </FormControl>
              <div className="display-2 ">
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(25, "repay")}
                >
                  25%
                </div>
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(50, "repay")}
                >
                  50%
                </div>
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(75, "repay")}
                >
                  75%
                </div>
                <div
                  className="brow-percent"
                  onClick={() => calculateAmount(100, "repay")}
                >
                  100%
                </div>
              </div>
            </div>
          )}
          <div className="br-shade"> </div>
          <div className="display-4 brow-cnf-btn p-20">
            <Button className="brow-btn" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              className="brow-btn"
              onClick={() => {
                borrowAndRepay(browTab == "Borrow" ? "borrow" : "repay");
              }}
            >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AssetView;
